
  import { defineComponent } from 'vue';

  import PageTitle from '@/common/components/redesigned/PageTitle.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import StatisticsPublicExportButtons from '../components/statistics/statistics-public/StatisticsPublicExportButtons.vue';
  import StatisticsPublicFilter from '../components/statistics/statistics-public/StatisticsPublicFilter.vue';
  import StatisticsPublicViewsCountTabs from '../components/statistics/statistics-public/StatisticsPublicViewsCountTabs.vue';
  import StatisticsPublicVisitsCountTabs from '../components/statistics/statistics-public/StatisticsPublicVisitsCountTabs.vue';
  import { TStatisticsPublicFilter } from '../types/statistics/statistics-public';

  const PERMISSIONS = {
    view: Constants.Permissions.AuditPublicStatisticView,
  };

  export default defineComponent({
    name: 'StatisticsPublic',
    components: {
      PageTitle,
      StatisticsPublicExportButtons,
      StatisticsPublicFilter,
      StatisticsPublicViewsCountTabs,
      StatisticsPublicVisitsCountTabs,
    },
    mixins: [security],
    data(): { filter: TStatisticsPublicFilter } {
      return {
        filter: {},
      };
    },
    created() {
      this.checkPermissionAndRedirect(PERMISSIONS.view);
    },
    methods: {
      searchFilter(newFilter: TStatisticsPublicFilter) {
        this.filter = newFilter;
      },
    },
  });
